import type { PortfolioAbilitiesResource } from "api/generated";
import { PORTFOLIO_ABILITIES } from "portfolio/constants";
import type { PortfolioAbilities } from "portfolio/types";

export const portfolioAbilitiesFromDto = (
  resource: PortfolioAbilitiesResource,
): PortfolioAbilities => ({
  [PORTFOLIO_ABILITIES.CAN_CREATE_TASK]: resource.can_create_task === true,
  [PORTFOLIO_ABILITIES.CAN_CREATE_PUBLIC_TASK]:
    resource.can_create_public_task === true,
  [PORTFOLIO_ABILITIES.CAN_CREATE_TEMPLATE]:
    resource.can_create_template === true,
});
